import { Loader } from '@googlemaps/js-api-loader';
import Vue from 'vue';

type RequiredPick<T, K extends keyof T> = { [P in K]: T[P];} & Partial<Omit<T, K>>;
export type GetPlacePredictionsRequest = RequiredPick<google.maps.places.AutocompletionRequest, 'input' | 'types'>;
export type GetDetailsRequest = RequiredPick<google.maps.places.PlaceDetailsRequest, 'placeId' | 'fields'>;

export interface IGoogleMapsLoader {
	initialized(): boolean;
	fetchAutocompleteSuggestions(request: GetPlacePredictionsRequest): Promise<{ suggestions: google.maps.places.AutocompleteSuggestion[]; }>;
	fetchFields(request: GetDetailsRequest): Promise<{place: google.maps.places.Place;}>;
	disableLoader(): void;
}

export class GoogleMapsLoader implements IGoogleMapsLoader {
	private loader: Loader;
	private sessionToken: google.maps.places.AutocompleteSessionToken;
	private googleSdk: google.maps.PlacesLibrary;
	private state = Vue.observable({
		initialized: false
	});

	constructor(apiKey: string) {
		this.load(apiKey);
	}

	private async load(apiKey: string) {
		this.loader = new Loader({ apiKey, version: 'quarterly' });
		this.loader.importLibrary('places').then(googleSdk => {
			this.googleSdk = googleSdk;
			this.sessionToken = new googleSdk.AutocompleteSessionToken();
			this.state.initialized = true;
		});
	}

	initialized() {
		return this.state.initialized;
	};

	fetchAutocompleteSuggestions(request: google.maps.places.AutocompleteRequest) {
		return this.googleSdk.AutocompleteSuggestion.fetchAutocompleteSuggestions({
			...request,
			sessionToken: this.sessionToken
		});
	};

	fetchFields(request: GetDetailsRequest) {
		const place = new this.googleSdk.Place({ id: request.placeId });
		return place.fetchFields({ fields: request.fields });
	};

	disableLoader() {
		this.state.initialized = false;
	};
};